/**
 * NAATI cluster — Wave 6 deep Q&A (document × visa/city × intent).
 * Deterministic, price-free, self-contained answers for AI answer engines.
 */
import { NAATI_DOC_TYPES, NAATI_VISAS, ALL_NAATI_CITIES } from "@/data/naati";
import { expandDeep, deepAsOf, type DeepAxis } from "@/data/_qa/deep-expander";
import type { NaatiQA } from "./questions-500";

const AS_OF = deepAsOf(
  "สิงหาคม 2569",
  "ข้อกำหนดของ Department of Home Affairs และหน่วยงานปลายทางเปลี่ยนได้ ควรยืนยันกับหน่วยงานผู้รับเอกสารก่อนยื่นทุกครั้ง",
);

const INTENTS: DeepAxis[] = [
  { slug: "student", th: "นักเรียนที่ยื่นเรียนต่อออสเตรเลีย" },
  { slug: "partner", th: "ผู้ยื่นวีซ่าคู่ครองหรือคู่หมั้น" },
  { slug: "skilled", th: "ผู้ยื่นวีซ่าทักษะหรือขอ Skills Assessment" },
  { slug: "onshore", th: "ผู้ที่อยู่ในออสเตรเลียแล้วและยื่นต่อ" },
  { slug: "agent", th: "เอเจนต์หรือที่ปรึกษาที่ยื่นแทนลูกค้า" },
];

const SECONDARY: DeepAxis[] = [
  ...NAATI_VISAS.map((v) => ({ slug: `visa-${v.slug}`, th: `การยื่น${v.nameTh}`, en: v.nameEn })),
  ...ALL_NAATI_CITIES.slice(0, 20).map((c) => ({ slug: `city-${c.slug}`, th: `ผู้ยื่นที่อยู่${c.nameTh}`, en: c.nameEn })),
];

export const NAATI_QA_WAVE6: NaatiQA[] = expandDeep<NaatiQA["cluster"]>({
  prefix: "naati-w6",
  asOf: AS_OF,
  authorityTh: "หน่วยงานผู้รับเอกสารในออสเตรเลีย",
  clusterTh: "งานแปลรับรอง NAATI",
  primary: NAATI_DOC_TYPES.map((d) => ({ slug: d.slug, th: `แปล NAATI ${d.nameTh}`, en: d.nameEn, note: `มักใช้กับ ${d.commonUse.slice(0, 2).join(" / ")}` })),
  secondary: SECONDARY,
  intents: INTENTS,
  clusters: { documents: "documents", process: "process", risk: "legal", location: "location" },
  cap: 330,
});
